// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__2Ptob","title":"Images90_title__3NFxG","images":"Images90_images__1iQyg"};